var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.images),function(img,i){return _c('img',{key:i,staticClass:"responsive",attrs:{"src":img,"alt":"","ondragstart":"return false;"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }